import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {noPropagate} from '@containers/hooks'
import {Task} from '@extensions/task'
import {useIdTask} from './use-id-tasks'

export const TwSticker = tw.a<{
  $isTaskColored?: boolean
  $isCompleted?: boolean
}>`
  h-24
  max-h-24
  flex
  items-center
  px-8
  border-1
  border-solid
  rounded-8
  
  ${p => {
    if (p.$isTaskColored) {
      return `
        border-icon-primary
        bg-transparent
        text-icon-primary
        hover:text-icon-primary
        hover:text-icon-primary
        visited:text-icon-primary
        focus:text-icon-primary
        ${
          p.$isCompleted
            ? 'opacity-[.38] hover:opacity-[.64] active:opacity-[.64]'
            : 'opacity-[.64] hover:opacity-100 active:opacity-100'
        }
      `
    }

    return `
      border-line-base
      bg-background-primary
      text-secondary
      hover:text-secondary
      hover:border-line-hover
      visited:text-secondary
      focus:text-secondary
    `
  }}
`
interface Props {
  task: Hub
  isTaskColored?: boolean
  isCompleted?: boolean
}

export const IdTasksTaskCardSticker = observer((props: Props) => {
  const {task} = props

  const idTask = useIdTask(task?.id)

  if (!task || !idTask) {
    return null
  }

  return (
    <Tooltip content={Lang.msg.proj.idTask} placement="bottom">
      <div onMouseDown={noPropagate} onClick={noPropagate}>
        <IdTasksStickerTitle
          idTask={idTask}
          task={task}
          isTaskColored={props.isTaskColored}
          isCompleted={props.isCompleted}
        />
      </div>
    </Tooltip>
  )
})

const IdTasksStickerTitle = ({
  idTask,
  task,
  isTaskColored,
  isCompleted
}: {
  idTask: string
  task: Hub
  isTaskColored?: boolean
  isCompleted?: boolean
}) => {
  return (
    <TwSticker
      $isTaskColored={isTaskColored}
      $isCompleted={isCompleted}
      href={Task.getLink(task)}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.button === 0) {
          Task.copyLink(task)
          void Tracking.send(TrackingEvent.copyTaskLinkBoard)
        }
      }}
    >
      {idTask}
    </TwSticker>
  )
}
